<template>
  <b-card
    title="مدیریت سگمنت پایه"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
        <b-row>
          <div class="filter-row">
            <b-col md="2">
              <b-form-group
                  label="عنوان"
                  label-for="Title"
              >
                <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                />
              </b-form-group>
            </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
          </div>
        </b-row>
        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(UserCount)="data">
            {{ data.value | price }}
          </template>

          <template #cell(LastUpdate)="data">
            {{ data.value | date('date-time') }}
          </template>

          <template #cell(actions)="data">
            <div
              class="text-nowrap "
            >
              <b-spinner
                v-if="data.item.loading"
                variant="secondary"
                small
              />
              <feather-icon
                v-else
                icon="RotateCwIcon"
                size="16"
                @click="updateSegment(data.item)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'SegmentBase',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'UserCount',
          label: 'تعداد کاربران',
        },
        {
          key: 'LastUpdate',
          label: 'آخرین بروزرسانی',
          tdClass: 'dir-ltr',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.segmentBasic.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
          this.items = this.items.map(item => { this.$set(item, 'loading', false); return item })
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.banner.remove, 'Id', id)
    },
    updateSegment(item) {
      item.loading = true
      this.$http.post(this.$api.segmentBasic.update, { Id: item.Id }).then(() => {
        item.loading = false
        this.update()
      })
    },
  },
}
</script>
